module.exports = __webpack_public_path__ + "img/searching-dark.cac85175.svg";